import {_utils} from "../../../utils/_utils.js";

export const ourServices = () => {
    return new Promise((resolve, reject) => {
        _utils.initSection('.our-services', (section, sectionIndex) => init(section, sectionIndex));
        resolve();
    })
}

const init = (section) => {
    const cards = section.querySelectorAll('.our-services__card')
    const loadMore = section.querySelector('.our-services__more')

    loadMore?.addEventListener('click', () => {
        cards?.forEach(card => card.classList.remove('hide'))
        // every card is revealed now — nothing left to load, so drop the button
        loadMore.remove()
    })
}



